import React from "react";
import * as authApi from "api/auth";
import { useNavigate } from "react-router-dom";
import MainContext from "contexts/main";
import Loading from "components/loading";
const WithoutAuth = ({ children }) => {
  let navigate = useNavigate();
  const [status, setStatus] = React.useState("loading");
  const { user, setUser } = React.useContext(MainContext);
  React.useEffect(() => {
    if (user) {
      navigate("/", { replace: true });
    } else {
      let token = localStorage.getItem("token");
      if (token) {
        authApi
          .profile()
          .then((res) => {
            setUser({ ...res.data, token: token });
            navigate("/", { replace: true });
          })
          .catch(() => {
            setStatus("loaded");
          });
      } else {
        setStatus("loaded");
      }
    }
  }, []);
  if (status === "loading") {
    return <Loading />;
  }
  return children;
};
export default WithoutAuth;
